import React from 'react';
import { Tooltip } from '@mui/material';
import { IconsTypesProps } from 'src/assets/icons/types';
import { useLocation, useNavigate } from 'react-router';
import useQueryParamsActions from 'src/hooks/useQueryParamsActions';
import { useAuthentication } from 'src/features/authentication/context';
import { AccessRoles } from 'src/features/user-account-details/types';
import { NavItem } from '../navItem';
import { StyledItemBox } from './style';

type Props = {
  title: string;
  url: string;
  icon: React.FunctionComponent<IconsTypesProps>;
  greyColor: string;
  activeItem: string;
  onSetActiveItemHandler: (newActiveItem: string) => void;
};

export const ExtendedNavItem = ({
  icon,
  title,
  greyColor,
  url,
  activeItem,
  onSetActiveItemHandler,
}: Props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    customerId: { value: customerId },
    siteId: { value: siteId },
    getCurrentRole,
  } = useAuthentication();
  const currentRole = getCurrentRole(customerId, siteId);
  const isReadOnlyRole =
    currentRole === AccessRoles.SITE_EMPLOYEE || currentRole === AccessRoles.SITE_MANAGER;

  const { get } = useQueryParamsActions();
  const templateId = get('templateId');
  const isHistory = title === 'History';
  const isSchedule = title === 'Schedule';
  const isScheduleDisabledByRole = isSchedule && isReadOnlyRole;

  const onClickHandler = () => {
    let shouldBlockNavigation = false;
    // if (blockNavigation && blockNavigation[0] && activeItem === 'Schedule') {
    //   shouldBlockNavigation = !confirmNavigationProceed();
    // }
    if (shouldBlockNavigation) return false;
    const currentQueryParams = location.search;
    navigate(`${url}${currentQueryParams}`);
    onSetActiveItemHandler(title);
  };

  return (
    <>
      {isScheduleDisabledByRole ? (
        <StyledItemBox>
          <NavItem
            testId={`${title.toLowerCase()}-extended-item`}
            title={title}
            icon={icon}
            greyColor={greyColor}
            activeItem={activeItem}
          />
        </StyledItemBox>
      ) : (isHistory && !templateId) || (isSchedule && !templateId) ? (
        <Tooltip title={isSchedule ? 'Save the template to enable scheduling' : 'No saved reports'}>
          <StyledItemBox>
            <NavItem
              testId={`${title.toLowerCase()}-extended-item`}
              title={title}
              icon={icon}
              greyColor={greyColor}
              activeItem={activeItem}
            />
          </StyledItemBox>
        </Tooltip>
      ) : (
        <NavItem
          title={title}
          icon={icon}
          greyColor={greyColor}
          activeItem={activeItem}
          onClickHandler={onClickHandler}
          testId={`${title.toLowerCase()}-extended-item`}
        />
      )}
    </>
  );
};
